import { UserCheck } from "lucide-react";
import { MultiSelectFilter } from "@/components/MultiSelectFilter";
import { assigneeFilterOptions } from "@/lib/assignee-filter";
import { useLeadAssignmentPolicy } from "@/hooks/useLeadAssignment";
import { useCurrentUserProfile } from "@/hooks/useUsers";
import { useCrmStore } from "@/stores/crm.store";

/**
 * «Asignado a». Renders nothing unless the client's lead assignment policy is
 * on — with it off every assignee is null and the filter could only empty the
 * list.
 */
export function AssigneeFilterSelect(): React.JSX.Element | null {
  const { data: policy } = useLeadAssignmentPolicy();
  const profile = useCurrentUserProfile();
  const assigneeIds = useCrmStore((s) => s.assigneeIds);
  const toggleAssignee = useCrmStore((s) => s.toggleAssignee);
  const clearAssignees = useCrmStore((s) => s.clearAssignees);

  if (!policy?.enabled || !profile) return null;

  return (
    <MultiSelectFilter
      options={assigneeFilterOptions(policy, profile)}
      selected={assigneeIds}
      onToggle={toggleAssignee}
      onClear={clearAssignees}
      placeholder="Asignado a"
      pluralNoun="responsables"
      singularNoun="responsable"
      clearLabel="Cualquier responsable"
      icon={UserCheck}
      ariaLabel="Asignado a"
      className="md:w-[170px]"
    />
  );
}
